export const VERSION_NOTES = [
  { version: '1.2.1.8', note: 'NimBLE rollout' },
  { version: '1.2.1.9', note: 'NimBLE revert' },
  { version: '1.2.1.16', note: 'NimBLE OTA Fixes + Mini Map + Preferences' },
  { version: '1.4.0', note: 'NimBLE (Beta)' },
  { version: '1.5.0', note: 'New Menu + Minor Map fixes (Beta)' },
  { version: '1.8.2', note: 'ESP IDF, Mini Map Improvements, BT Security' },
];
